export default "__VITE_ASSET__9f2c4e10__"